import { useContext, useRef, useState } from "react";
import { useHistory } from "react-router-dom";

import API from "Signups/API";
import { SignupsAppState } from "Signups/state.js";

import FnrIcon from "UI/FnrIcon";

import DeleteConfirmation from "./DeleteConfirmation";
import { MoreButton, MoreButtonText } from "./MoreButton";

export default function ArchiveSignup() {
  const [
    {
      currentSignupList: { ID: signupListID, signupItems },
    },
    dispatch,
  ] = useContext(SignupsAppState);

  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const toggleShowConfirmation = () =>
    setShowConfirmation((currentVal) => !currentVal);

  const buttonRef = useRef();

  const currentListHasSignups = () => {
    for (let item of signupItems) {
      if (item.respondents?.length) return true;
    }

    return false;
  };

  const peopleHaveSignedUp = currentListHasSignups();

  const width = window.innerWidth;

  return (
    <>
      <MoreButton
        onClick={toggleShowConfirmation}
        disabled={isLoading}
        forceHover={showConfirmation || isLoading}
        color="#B4252D"
        ref={buttonRef}
      >
        <FnrIcon far fa-trash-alt />
        <MoreButtonText>Delete Signup</MoreButtonText>
      </MoreButton>
      <DeleteConfirmation
        show={showConfirmation}
        buttonRef={buttonRef}
        signupListID={signupListID}
        peopleHaveSignedUp={peopleHaveSignedUp}
        closePopover={toggleShowConfirmation}
      />
    </>
  );
}
